$(document).ready(function(){

  var filtersToggler = $('[js-mobile-filters-toggle]');
  var toggleOpenClass = 'sl-filters-opened';

  filtersToggler.on('click', function() {

    if ($('body').hasClass(toggleOpenClass)) {
      $('body').removeClass(toggleOpenClass);
    }
    else {
      $('body').addClass(toggleOpenClass);
    }

  });

});



// WEBPACK FOOTER //
// ./assets/scripts/map/components/_toggle-filters.js